module.exports = __webpack_public_path__ + "img/18.9e5f9f11.jpg";